import React from "react";
import TPCLearnerLogin from "../../TPC_Group_Manual_Register/TPCLearnerLogin";

export default function TradeApplicationLogin() {
  return (
    <TPCLearnerLogin
      applicationScope="trade"
      loginTitle="Trade Application Login"
      welcomeText="Trade Application"
      learnerFlag={true}
      alternateLoginRoute="/ai-professional-application-login"
      alternateLoginLabel="AI Professional application"
    />
  );
}
